import AdjacentSliceGhostLegend from './AdjacentSliceGhostLegend';
import type { Environment } from '~/engine/data/Environment';
import { RenderAdapter } from '~/viewportGrid/adapters/types';
import { usePlaneViewHostedBy } from '../usePlaneViewHostedBy';

interface TileAdjacentSliceGhostLegendMountProps {
    renderer: RenderAdapter;
    /** The Environment whose tiles show the legend; undefined hides it. */
    legendHost: Environment | undefined;
}

/**
 * Mounts the adjacent-slice ghost legend over one grid tile, on every tile
 * of the Environment that hosts it. The engine draws the ghosts of the
 * selected structure on every view of that Environment, whichever image of
 * a fused pair the view shows, so every such tile names their sides. The
 * legend owns what it shows; this mount owns nothing but the gate. Renders
 * nothing for non-engine renderers (the mock adapters).
 */
export default function TileAdjacentSliceGhostLegendMount({
    renderer,
    legendHost,
}: TileAdjacentSliceGhostLegendMountProps) {
    const view = usePlaneViewHostedBy(renderer, legendHost);
    if (!view) {
        return null;
    }
    return <AdjacentSliceGhostLegend view={view} />;
}
